import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DefaultSelectionValue, FormGroupValue, InputProps } from '../input-props';

@Component({
  selector: 'miq-equals-filter',
  templateUrl: './equals-filter.component.html',
  styleUrls: ['./equals-filter.component.scss'],
  standalone: false,
})
export class EqualsFilterComponent<T = DefaultSelectionValue> implements OnInit {
  @Input() props: InputProps<T>;
  @Output() search = new EventEmitter<FormGroupValue<T> | string>();
  control: UntypedFormControl;

  ngOnInit(): void {
    this.control = new UntypedFormControl(this.props.value, this.props.controlOptions || {});
  }

  doSearch($event) {
    const { value } = $event.target;
    this.control.setValue(value);
    if (this.props.field) {
      this.search.emit({ [this.props.field]: value });
    } else {
      this.search.emit(value);
    }
  }
}
